import { render, staticRenderFns } from "./LabelComponent.vue?vue&type=template&id=1a277ec6&scoped=true&"
import script from "./LabelComponent.vue?vue&type=script&lang=ts&"
export * from "./LabelComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LabelComponent.vue?vue&type=style&index=0&id=1a277ec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a277ec6",
  null
  
)

export default component.exports